export default __webpack_public_path__ + "static/media/account.ba5d09e3.svg";